module.exports = __webpack_public_path__ + "static/media/award.7a94f284.svg";